const digitalSkillsregistrationDetails = {
  points: [
    {
      icon: "calendar",
      title: "Date",
      description: "June 27, 2025.",
    },
    {
      icon: "time",
      title: "Time",
      description: "8:30 AM",
    },
    {
      icon: "location",
      title: "Location",
      description: `In-person at MTN Head Office, Independence Avenue, Accra. Online attendance also available.`, //! Full Adreess - MTN House, Independence Avenue, Accra | P.O. Box TF281, Trade Fair, La, Accra, Ghana.
    },
    {
      icon: "edit",
      title: "Registration is free",
      description:
        "100 in-person seats available for Accra residents;  individuals outside Accra may attend online.",
    },
    {
      icon: "bookmark",
      title:
        "Complete any course on MTN Skills Academy to stand a chance to win a prize.",
      description: "",
      link: {
        name: "Go to skillsacademy.mtn.com",
        url: "https://skillsacademy.mtn.com/signin",
      },
    },
  ],
  about: "",
  host: "",
  benefits: [
    "Gain big network of high profile personalities to assist in your job opportunities and future careers",
    "Acquire secrets to transform yourself & your community",
    "Gain Mentoring and Coaching opportunities from YPYC",
    "Certificate of Participation",
    "Conference Materials",
    "Snacks (in person)",
    "Etc.",
  ],
  mediaPartners: "",
  mediaPartnersLogos: "",
  maxParticipants: 100,
};

const attendanceOptions = ["In-person", "Virtual via Zoom"];
const eventCode = "Stanbic_DST_TEST_L1";
const organizer = "Stanbic";
const eventName = "Digital Skills Training";

export {
  digitalSkillsregistrationDetails,
  attendanceOptions,
  eventCode,
  eventName,
  organizer,
};
